import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import ThinkTankCategory from '@/types/table/thinkTankCategory';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface ThinkTankCategoryData extends ThinkTankCategory {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class ThinkTankCategoryController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<ThinkTankCategoryData>>(API_CONTEXT + '/app/thinkTankCategory/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ThinkTankCategoryData>(API_CONTEXT + '/app/thinkTankCategory/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/thinkTankCategory/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/thinkTankCategory/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/thinkTankCategory/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/thinkTankCategory/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/thinkTankCategory/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/thinkTankCategory/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/thinkTankCategory/deleteBatch', params, httpOptions);
  }
}
